export default "__VITE_ASSET__CbB6_uLo__"